import { render, staticRenderFns } from "./HomeSlider.vue?vue&type=template&id=af10bbfa&scoped=true&"
import script from "./HomeSlider.vue?vue&type=script&lang=ts&"
export * from "./HomeSlider.vue?vue&type=script&lang=ts&"
import style0 from "./HomeSlider.vue?vue&type=style&index=0&id=af10bbfa&prod&lang=scss&scoped=true&"
import style1 from "./HomeSlider.vue?vue&type=style&index=1&id=af10bbfa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af10bbfa",
  null
  
)

export default component.exports